import type { Result } from '../types';

function parseTimeOrNegInf(iso: string | undefined): number {
  if (!iso) return Number.NEGATIVE_INFINITY;
  const t = Date.parse(iso);
  return Number.isNaN(t) ? Number.NEGATIVE_INFINITY : t;
}

/**
 * Returns a new array sorted by race date in descending order (newest first).
 * Invalid/missing dates are pushed to the end to keep ordering predictable.
 */
export function sortResultsByRaceDate(results: Result[]): Result[] {
  return [...results].sort((a, b) => {
    const normalizedB = parseTimeOrNegInf(b.race_date);
    const normalizedA = parseTimeOrNegInf(a.race_date);
    return normalizedB - normalizedA;
  });
}

/**
 * Returns a new array sorted by competition `start_date` descending (newest first).
 * Rows without a parseable competition date sort after dated rows.
 */
export function sortResultsByCompetitionStartDate(results: Result[]): Result[] {
  return [...results].sort((a, b) => {
    const normalizedB = parseTimeOrNegInf(b.start_date);
    const normalizedA = parseTimeOrNegInf(a.start_date);
    return normalizedB - normalizedA;
  });
}
